export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8764.fa552da1.jpg";